import * as React from "react";

export const IconQuestionMark: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg
        width={9}
        height={14}
        viewBox="0 0 9 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M4.314 10.93a.842.842 0 0 1-.841-.84 3.842 3.842 0 0 1 2.045-3.451 2.626 2.626 0 1 0-3.835-2.334.841.841 0 1 1-1.683 0A4.284 4.284 0 0 1 1.624.94 4.336 4.336 0 0 1 5.312.115a4.262 4.262 0 0 1 3.19 3.19 4.342 4.342 0 0 1-2.218 4.834 2.193 2.193 0 0 0-1.134 1.955.841.841 0 0 1-.836.836ZM4.31 13.743a.828.828 0 1 0 0-1.655.828.828 0 0 0 0 1.655Z"
            fill="currentColor"
        />
    </svg>
);
